import { useState } from "react";
import { Server } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import { Input } from "./ui/input";
import { Label } from "./ui/label";

export function SetupRouterDialog({ open, onClose, request, onDone }) {
  const [form, setForm] = useState({ host: "", port: 8728, username: "admin", password: "", winbox_port: 8291, dns_name: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post(`/branch-requests/${request.id}/setup-router`, { ...form, port: Number(form.port) || 8728, winbox_port: Number(form.winbox_port) || 0 });
      toast.success(`Terhubung ke ${data.identity || "MikroTik"} — ${data.hotspot.length} profile hotspot & ${data.ppp.length} profile PPP dibuat di router`);
      onDone?.(); onClose();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md" data-testid="setup-router-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-heading"><Server className="w-5 h-5 text-sky-500" /> Isi Host & Login — {request?.name}</DialogTitle>
          <DialogDescription>Sistem akan mencoba login ke MikroTik; bila berhasil, semua profile standar cabang ini (voucher & PPPoE) otomatis <b>dibuat di router</b> beserta scheduler masa aktif. Kredensial hanya disimpan jika koneksi berhasil.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div className="grid grid-cols-[1fr_90px] gap-2">
            <div className="space-y-1.5"><Label>Host / IP MikroTik</Label><Input value={form.host} onChange={(e) => setForm({ ...form, host: e.target.value })} required placeholder="mis. 10.10.10.2 atau vpn.cabang.id" className="font-mono" data-testid="sr-host" /></div>
            <div className="space-y-1.5"><Label>Port API</Label><Input type="number" value={form.port} onChange={(e) => setForm({ ...form, port: e.target.value })} className="font-mono" data-testid="sr-port" /></div>
          </div>
          <div className="grid grid-cols-2 gap-2">
            <div className="space-y-1.5"><Label>Username</Label><Input value={form.username} onChange={(e) => setForm({ ...form, username: e.target.value })} required className="font-mono" data-testid="sr-username" /></div>
            <div className="space-y-1.5"><Label>Password</Label><Input type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required className="font-mono" data-testid="sr-password" /></div>
          </div>
          <div className="grid grid-cols-2 gap-2">
            <div className="space-y-1.5"><Label>Port Winbox</Label><Input type="number" value={form.winbox_port} onChange={(e) => setForm({ ...form, winbox_port: e.target.value })} className="font-mono" data-testid="sr-winbox" /></div>
            <div className="space-y-1.5"><Label>DNS Hotspot (login)</Label><Input value={form.dns_name} onChange={(e) => setForm({ ...form, dns_name: e.target.value })} placeholder="fas.net" className="font-mono" data-testid="sr-dns" /></div>
          </div>
          <div className="grid grid-cols-2 gap-2">
            <Button type="button" variant="outline" onClick={onClose} data-testid="sr-cancel">Batal</Button>
            <Button type="submit" disabled={busy} className="bg-sky-600 hover:bg-sky-700 text-white" data-testid="sr-submit">{busy ? "Menghubungkan & membuat profile..." : "Simpan & Buat di Router"}</Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
